<template>

  <q-page padding>
    <div class="row justify-center">
      <q-card flat bordered class="col-6 col-md-4">
        <form action @submit.prevent="loginService">
          <q-card-section>
            <div class="text-h6">Login</div>
          </q-card-section>

          <q-card-section>
              <q-input outlined v-model="username" type="text" label="Usuario" required></q-input>
              <q-input outlined v-model="password" type="password" label="Password" required></q-input>
          </q-card-section>

          <q-separator inset />

          <q-card-actions vertical>
            <q-btn flat type="submit">Login</q-btn>
          </q-card-actions>
        </form>
      </q-card>
      
    </div>

  </q-page>
  
</template>

<script>
import store from '@/store';
import axios from 'axios';
import {userService} from './../_services/user.service';

export default {
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    
    checkLogin() {
      let url = store.state.urlBase + '/api/auth/login';
      let options = {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type' : 'application/json',
          },
      };
      let form = {
        username: this.username,
        password: this.password
      }

      // Via axios
      axios.post(url, form, options)
        .then(response => {
            console.log('response.data:',response.data);
            let result = response.data;
            if (result.access_token) {
                let token = result.access_token
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('userToken', token);
                // let user = atob(token.split('.')[1])
                // localStorage.setItem('user', user);
                console.log('validado!');
                this.$router.push('/dashboard')
            }
        })
        .catch(error => {
            console.log('Error en login: ',error)
        });

    },

    loginService() {
      userService.login(this.username, this.password)
      .then( data => {
        console.log('data from LoginService: ', data);
        store.commit('setUser', {token: data.access_token});
        this.$router.push('/dashboard');
      }).catch(error => console.log('catch login service', error))
    },

  },
  mounted() {
    // 
  }
}
</script>

